module.exports = __webpack_public_path__ + "023835f5a086f15212ea5dacf8529877.fbx";